export default "__VITE_ASSET__DFYKESSF__"